import { ClientMethod } from 'openapi-fetch'

interface Input<T> {
  method: T
  returnAllErrors?: boolean
}

/**
 * Higher order function that is used by the OpenAPI client to capture the error instead of throwing
 *
 * NOTE: this used to capture the error in sentry, but with the shift to RUM it is better to capture the errors with direct fetch hook
 * since this utility is shared across fe/be it was not appropriate to add RUM directly to it.
 *
 * TODO(klaus): consider removing this completely, it is kept for now since it does some modifications to the error which I don't know if they are safe to remove.
 * */

export function withErrorCapture<T extends ClientMethod<any, any, any>>({
  method,
  returnAllErrors = false, // NOTE(Ramon): Default to false for backwards compatibility
}: Input<T>): T {
  return (async (...args: [any, ...any[]]) => {
    let result

    try {
      result = await method(...args)
    } catch (err) {
      // Catch errors which openapi-fetch throws rather than returns in response
      // e.g. CORS errors
      return { error: new Error('Fetch failed', { cause: err }) }
    }

    const { response, error } = result
    if (result.response.ok) {
      return result
    }

    if (!error) {
      return result
    }

    // Need to modify the return value here to only return data
    return { error }
  }) as T
}
